import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { z } from 'zod';
import { passwordSchema } from '@barbeiropro/contracts';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field } from '@/components/shared/field';
import { api, errorMessage } from '@/lib/api';
import { AuthLayout } from './auth-layout';
import { FormError } from './form-error';
import { toast } from 'sonner';

const schema = z
  .object({ password: passwordSchema, confirm: z.string() })
  .refine((v) => v.password === v.confirm, { path: ['confirm'], message: 'As senhas não conferem' });

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') ?? '';
  const [error, setError] = useState<string | null>(null);
  const form = useForm<z.infer<typeof schema>>({ resolver: zodResolver(schema) });
  const { errors, isSubmitting } = form.formState;
  const onSubmit = form.handleSubmit(async (v) => {
    setError(null);
    try {
      await api.post('/auth/reset-password', { token, password: v.password });
      toast.success('Senha redefinida. Entre com a nova senha.');
      navigate('/entrar', { replace: true });
    } catch (e) {
      setError(errorMessage(e));
    }
  });
  return (
    <AuthLayout title="Nova senha" footer={<Link to="/entrar" className="underline-offset-4 hover:underline">Voltar para entrar</Link>}>
      {!token ? (
        <FormError message="Link incompleto. Abra o link do e-mail novamente." />
      ) : (
        <form onSubmit={onSubmit} className="grid gap-4" noValidate>
          <FormError message={error} />
          <Field id="password" label="Nova senha" error={errors.password?.message}>
            <Input id="password" type="password" autoComplete="new-password" {...form.register('password')} />
          </Field>
          <Field id="confirm" label="Repita a senha" error={errors.confirm?.message}>
            <Input id="confirm" type="password" autoComplete="new-password" {...form.register('confirm')} />
          </Field>
          <Button type="submit" size="lg" disabled={isSubmitting}>
            Salvar nova senha
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
